module.exports = __webpack_public_path__ + "img/sv15on.f88b39cc.svg";